export const /** @type {?} */ TNK_FEEDBACK_FIRST_LOAN_COOKIE = 'TNK-FEEDBACK-FIRST-LOAN';
export const /** @type {?} */ TNK_LOAN_SUCCESS_USER = 'TNK-LN-SUCCESS-USER';
export const /** @type {?} */ TNK_OTP_SENDED = 'TNK-OTP-SENDED';
export const /** @type {?} */ TNK_TOKEN = 'tnk_token';
